export var FILE = "__NATIVE_FILE__";
export var URL = "__NATIVE_URL__";
export var TEXT = "__NATIVE_TEXT__";
